/**
 * Welcome-onboarding AppShell suppress gate.
 *
 * Guest drafts never suppress the shell (review modals own post-signup UX).
 * New signups with requiresWelcomePlanWall (PBI #1258) block AppShell until
 * Free or Personal. Pre-cutoff pending users do not suppress. Campaign claim
 * still covers the shell until status arrives so Overview cannot flash under
 * a pending intro slug.
 */

import { hasGuestDraft, hasGuestFlowerDraft, hasGuestMailedCardDraft } from '../../services/guestDraftService';
import { hasCampaignSlug } from '../../services/campaignSlugService';
import type { SubscriptionStatus } from '../../types/subscription';

/**
 * Returns true when the AppShell should be omitted so only WelcomeOnboarding
 * owns the viewport.
 *
 * @param requiresWelcomePlanWall - From SubscriptionContext (PBI #1258 cutoff gate)
 * @param isSubscribed - From SubscriptionContext
 * @param subscription - Raw status; null means still pending first fetch
 */
export function shouldSuppressAppShellForOnboarding(
  requiresWelcomePlanWall: boolean,
  isSubscribed: boolean,
  subscription: SubscriptionStatus | null,
): boolean {
  if (hasGuestDraft() || hasGuestFlowerDraft() || hasGuestMailedCardDraft()) {
    return false;
  }

  if (requiresWelcomePlanWall) {
    return true;
  }

  // Campaign claim fallback: cover the shell until status arrives so Overview
  // cannot flash under a pending intro-offer slug.
  return hasCampaignSlug() && !isSubscribed && subscription === null;
}
